import { buildSettingsBadge } from '@/lib/chat/settings-badge'
import { DEMO_COMPARE_BATCH_ID, type CompareBatch } from '@/types/compare'

export function createDemoCompareBatch(): CompareBatch {
  const settings = { temperature: 0.5, topP: 0.9, maxTokens: 4096, jsonMode: false }

  return {
    id: DEMO_COMPARE_BATCH_ID,
    title: 'Rust binary search comparison',
    promptText: 'Write a binary search in Rust',
    createdAt: new Date().toISOString(),
    responses: [
      {
        modelResponseId: 'resp-gpt4o',
        sessionId: 'session-gpt4o',
        modelId: 'model-rated-demo',
        categoryId: 'cat-coding',
        model: { displayName: 'GPT-4o', slug: 'gpt-4o' },
        provider: { name: 'OpenRouter' },
        category: { name: 'Coding' },
        settingsSnapshot: settings,
        settingsBadge: buildSettingsBadge(settings),
        normalizedText: 'Here is a binary search in Rust:\n\nfn binary_search(arr: &[i32], target: i32) -> Option<usize> {\n    // ...\n}',
        tokensInput: 15,
        tokensOutput: 240,
        estimatedCost: 0.0000027,
        latencyMs: 1240,
        status: 'completed',
        rating: null,
      },
      {
        modelResponseId: 'resp-claude',
        sessionId: 'session-claude',
        model: { displayName: 'Claude 3.5', slug: 'claude-3-5' },
        provider: { name: 'OpenRouter' },
        category: { name: 'Coding' },
        settingsSnapshot: settings,
        settingsBadge: buildSettingsBadge(settings),
        normalizedText: '```rust\nfn binary_search(slice: &[i32], needle: i32) -> Option<usize> {\n    // implementation\n}\n```',
        tokensInput: 14,
        tokensOutput: 210,
        estimatedCost: 0.0000015,
        latencyMs: 980,
        status: 'completed',
        rating: null,
      },
      {
        modelResponseId: 'resp-llama',
        sessionId: 'session-llama',
        model: { displayName: 'Llama 3.3 70B', slug: 'llama-3-3-70b' },
        provider: { name: 'OpenRouter' },
        category: { name: 'Research' },
        settingsSnapshot: settings,
        settingsBadge: buildSettingsBadge(settings),
        normalizedText: 'Below is a Rust implementation of binary search with explicit bounds checking.',
        tokensInput: 13,
        tokensOutput: 190,
        estimatedCost: 0,
        latencyMs: 770,
        status: 'completed',
        rating: null,
      },
    ],
  }
}
